/* WattWheelz seasonal promo bridge — source of truth: Shopify theme settings */
(function(){
  'use strict';

  function getConfig(){
    return window.WWSeasonalEvent || {};
  }

  function apply(){
    var cfg=getConfig();
    var event=document.querySelector('.ww-header-event');
    if(event){
      var link=event.querySelector('a');
      if(link){
        link.href='/pages/promotions';
        link.textContent='Shop Promotions';
      }
      event.classList.add('is-campaign-ready');
    }

    var box=document.querySelector('[data-ww-promo-countdown]');
    if(box && cfg.deadlineIso){
      box.setAttribute('data-deadline',cfg.deadlineIso);
      box.classList.remove('is-ended');
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);else apply();
  document.addEventListener('shopify:section:load',apply);
})();